'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initContainers = exports.state = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

require('core-js/modules/es6.typed.array-buffer');

require('core-js/modules/es6.typed.int8-array');

require('core-js/modules/es6.typed.uint8-array');

require('core-js/modules/es6.typed.uint8-clamped-array');

require('core-js/modules/es6.typed.int16-array');

require('core-js/modules/es6.typed.uint16-array');

require('core-js/modules/es6.typed.int32-array');

require('core-js/modules/es6.typed.uint32-array');

require('core-js/modules/es6.typed.float32-array');

require('core-js/modules/es6.typed.float64-array');

require('core-js/modules/es6.map');

require('core-js/modules/es6.set');

require('core-js/modules/es6.weak-map');

require('core-js/modules/es6.weak-set');

require('core-js/modules/es6.reflect.apply');

require('core-js/modules/es6.reflect.construct');

require('core-js/modules/es6.reflect.define-property');

require('core-js/modules/es6.reflect.delete-property');

require('core-js/modules/es6.reflect.get');

require('core-js/modules/es6.reflect.get-own-property-descriptor');

require('core-js/modules/es6.reflect.get-prototype-of');

require('core-js/modules/es6.reflect.has');

require('core-js/modules/es6.reflect.is-extensible');

require('core-js/modules/es6.reflect.own-keys');

require('core-js/modules/es6.reflect.prevent-extensions');

require('core-js/modules/es6.reflect.set');

require('core-js/modules/es6.reflect.set-prototype-of');

require('core-js/modules/es6.promise');

require('core-js/modules/es6.symbol');

require('core-js/modules/es6.object.freeze');

require('core-js/modules/es6.object.seal');

require('core-js/modules/es6.object.prevent-extensions');

require('core-js/modules/es6.object.is-frozen');

require('core-js/modules/es6.object.is-sealed');

require('core-js/modules/es6.object.is-extensible');

require('core-js/modules/es6.object.get-own-property-descriptor');

require('core-js/modules/es6.object.get-prototype-of');

require('core-js/modules/es6.object.keys');

require('core-js/modules/es6.object.get-own-property-names');

require('core-js/modules/es6.object.assign');

require('core-js/modules/es6.object.is');

require('core-js/modules/es6.function.name');

require('core-js/modules/es6.string.raw');

require('core-js/modules/es6.string.from-code-point');

require('core-js/modules/es6.string.code-point-at');

require('core-js/modules/es6.string.repeat');

require('core-js/modules/es6.string.starts-with');

require('core-js/modules/es6.string.ends-with');

require('core-js/modules/es6.string.includes');

require('core-js/modules/es6.regexp.flags');

require('core-js/modules/es6.regexp.match');

require('core-js/modules/es6.regexp.replace');

require('core-js/modules/es6.regexp.split');

require('core-js/modules/es6.regexp.search');

require('core-js/modules/es6.array.from');

require('core-js/modules/es6.array.of');

require('core-js/modules/es6.array.copy-within');

require('core-js/modules/es6.array.find');

require('core-js/modules/es6.array.find-index');

require('core-js/modules/es6.array.fill');

require('core-js/modules/es6.array.iterator');

require('core-js/modules/es6.number.is-finite');

require('core-js/modules/es6.number.is-integer');

require('core-js/modules/es6.number.is-safe-integer');

require('core-js/modules/es6.number.is-nan');

require('core-js/modules/es6.number.epsilon');

require('core-js/modules/es6.number.min-safe-integer');

require('core-js/modules/es6.number.max-safe-integer');

require('core-js/modules/es6.math.acosh');

require('core-js/modules/es6.math.asinh');

require('core-js/modules/es6.math.atanh');

require('core-js/modules/es6.math.cbrt');

require('core-js/modules/es6.math.clz32');

require('core-js/modules/es6.math.cosh');

require('core-js/modules/es6.math.expm1');

require('core-js/modules/es6.math.fround');

require('core-js/modules/es6.math.hypot');

require('core-js/modules/es6.math.imul');

require('core-js/modules/es6.math.log1p');

require('core-js/modules/es6.math.log10');

require('core-js/modules/es6.math.log2');

require('core-js/modules/es6.math.sign');

require('core-js/modules/es6.math.sinh');

require('core-js/modules/es6.math.tanh');

require('core-js/modules/es6.math.trunc');

require('core-js/modules/es7.array.includes');

require('core-js/modules/es7.object.values');

require('core-js/modules/es7.object.entries');

require('core-js/modules/es7.object.get-own-property-descriptors');

require('core-js/modules/es7.string.pad-start');

require('core-js/modules/es7.string.pad-end');

require('core-js/modules/web.timers');

require('core-js/modules/web.immediate');

require('core-js/modules/web.dom.iterable');

require('regenerator-runtime/runtime');

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _Helpers = require('common/Helpers');

var _subscribers = require('./subscribers');

var _handlers = require('./handlers');

var _product = require('./product');

var _lineItem = require('./line-item');

var _slider = require('./slider');

var _cart = require('./cart');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = exports.state = window.prg.state;

var defaultParsers = (0, _defineProperty3.default)({
  product: _product.initProductContainer,
  slider: _slider.initSliderContainer
}, 'line-item', _lineItem.initLineItemContainer);

var addContainerId = function addContainerId() {
  $('[data-container]:not([data-container-id])').each(function (index, element) {
    return $(element).attr('data-container-id', Math.floor(Math.random() * 1000000000));
  });
};

var initContainers = exports.initContainers = function initContainers(_ref) {
  var type = _ref.type,
      customParser = _ref.parser;

  addContainerId();

  var parser = customParser || defaultParsers[type];
  var containers = (0, _Helpers.getContainer)({ type: type }).filter(function (container) {
    return !Object.keys((0, _handlers.getState)(type)).includes(container.dataset.containerId);
  }).map(function (container) {
    return parser(container);
  });

  return Promise.all(containers).then(function (data) {
    PubSub.publish(_Constants2.default.initState + '.ALL_' + (0, _Helpers.constCase)(type), data);
    return data;
  });
};

var init = function init() {
  var products = initContainers({ type: 'product' });
  var lineItems = initContainers({ type: 'line-item' });
  var sliders = initContainers({ type: 'slider' });

  return Promise.all([products, lineItems, sliders]).then(function (_ref2) {
    var _ref3 = (0, _slicedToArray3.default)(_ref2, 3),
        products = _ref3[0],
        lineItems = _ref3[1],
        sliders = _ref3[2];

    var topic = _Constants2.default.initState + '.ALL';
    var data = { products: products, 'line-items': lineItems, sliders: sliders };

    PubSub.publish(topic, data);
  });
};

if ($('[data-home-featured-products]').length) {
  window.DY.API('callback', function () {
    window.DYO.waitForElement('[data-home-featured-products] [data-from-shopify]', function () {
      init();
    }, 1, 500, 10);
  });
}

exports.default = {
  init: init,
  initSubscribers: _subscribers.initSubscribers,
  get: _handlers.getState,
  set: _handlers.setState,
  clear: _handlers.clearState,
  cacheCart: _cart.cacheCart
};